import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import configureStore from "./store/configureStore";
import { Provider } from "react-redux";
import "./assets/styles/includes.scss";
import { mouseKeyboardAccessHelpers } from './utils/accessibility';
import { unregister } from './registerServiceWorker';

unregister();
//utils
mouseKeyboardAccessHelpers();

const store = configureStore();

ReactDOM.render(
	<Provider store={store}>
      <App />
	</Provider>,
	document.getElementById("root")
);





// WEBPACK FOOTER //
// ./src/index.js